import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import iview from 'view-design'
import Vant from 'vant';
import preview from 'vue-photo-preview'
import VueMeta from 'vue-meta'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'view-design/dist/styles/iview.css'
import 'vue-photo-preview/dist/skin.css'
import 'swiper/dist/css/swiper.css'
import './assets/icon/iconfont.css'
import './assets/styles/reset.styl'
import 'vant/lib/index.css';

Vue.use(VueAwesomeSwiper)
Vue.use(iview)
Vue.use(Vant);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

const options = {
  fullscreenEl:false, //关闭全屏按钮
  zoomEl: false,
	bgOpacity : 0.7,
	tapToClose: true
}
Vue.use(preview, options)

import filter from './assets/js/filter'
for(let key in filter){
  Vue.filter(key, filter[key])
}

Vue.prototype.$store = store
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
